@if (state() !== hubState.Connected) {
    <button
        *transloco="let t"
        mat-icon-button
        type="button"
        [class]="warningTextClass"
        (click)="reconnect()"
        [matTooltip]="
            state() === hubState.Reconnecting
                ? t('connection.reconnecting')
                : t('connection.disconnected')
        "
        [attr.aria-label]="
            state() === hubState.Reconnecting
                ? t('connection.reconnectingAria')
                : t('connection.disconnectedAria')
        "
    >
        <mat-icon
            [svgIcon]="
                state() === hubState.Reconnecting
                    ? 'heroicons_outline:arrow-path'
                    : 'heroicons_outline:signal-slash'
            "
        ></mat-icon>
    </button>
}
